import { render, staticRenderFns } from "./flight-pad-price-button.vue?vue&type=template&id=a248b68c&scoped=true"
import script from "./flight-pad-price-button.vue?vue&type=script&lang=js"
export * from "./flight-pad-price-button.vue?vue&type=script&lang=js"
import style0 from "./flight-pad-price-button.vue?vue&type=style&index=0&id=a248b68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a248b68c",
  null
  
)

export default component.exports